import React from 'react';
import './ExternalEventModal.css';

interface ExternalEventModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  externalUrl: string;
}

const ExternalEventModal: React.FC<ExternalEventModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  externalUrl 
}) => {
  if (!isOpen) return null;

  return (
    <div className="external-modal-overlay" onClick={onClose}>
      <div className="external-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="external-modal-header">
          <i className="fas fa-exclamation-triangle"></i>
          <h2>Leaving Musicade</h2>
        </div>
        
        <div className="external-modal-body">
          <p>
            You're leaving Musicade. We can't guarantee the ticket's availability, 
            price, or refunds.
          </p>
          <div className="external-url-preview">
            <i className="fas fa-external-link-alt"></i>
            <span>{externalUrl}</span>
          </div>
        </div>
        
        <div className="external-modal-footer">
          <button 
            className="external-modal-btn cancel-btn" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="external-modal-btn confirm-btn" 
            onClick={onConfirm}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExternalEventModal;
